// extracted by mini-css-extract-plugin
export default {"services_container":"Services_services_container__pekac"};